<template>
  <div v-if="show" class="fixed inset-0 flex flex-col items-center justify-center text-white bg-green-700 bg-opacity-75 space-y-4 z-40">
    <font-awesome-icon :icon="['fal', 'spinner-third']" size="2x" spin />
    <span class="text-2xl">Uploading...</span>
  </div>
</template>
<script>
export default {
  computed: {
    show () {
      return this.$store.state.loading.uploading
    }
  }
}
</script>
